import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import Breadcrumb from '../components/breadcrumb/Breadcrumb';
import PanelSidebar from '../components/panel/PanelSidebar';
import Reports from '../components/panel/report/Reports';
import { appendScript, removeScript, scrollToTopAnimated } from '../components/utils';
import { getProductsReports } from '../app/store/actions/reports';

class ReportPage extends React.PureComponent {
  componentDidMount = () => {
    removeScript('/scripts/panel.min.js');
    appendScript('/scripts/panel.min.js');

    scrollToTopAnimated();
  }

  componentWillUnmount = () => {
    removeScript('/scripts/panel.min.js');
  }

  render() {
    return (
      <main>
        <div className="section section-panel">
          <div className="container">
            <h1 className="panel-title">{I18n.t('report')}</h1>

            <div className="panel-content">

              <PanelSidebar />

              <button
                type="button"
                className="btn"
                onClick={() => this.props.getDocumentPdf()}
                style={{ width: 260 }}
              >
                {I18n.t('generateContract')}
              </button>

            </div>

          </div>
        </div>
      </main>
    );
    return (
      <main className="main">
        <div className="container">
          <Breadcrumb items={[{
            value: I18n.t('panel'),
          }, {
            value: I18n.t('report'),
          }]}
          />
          <div className="row">
            <PanelSidebar />
            <Reports />
          </div>
        </div>
      </main>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getDocumentPdf: () => dispatch(getProductsReports()),
});

export default connect(undefined, mapDispatchToProps)(ReportPage);
